require("./home");
require("./cjmy");
require("./appFarmFront");
require("./appIot");
require("./numFarm");
require("./appNumFarm");
require("./appIndustryFarm");
require("./appAboutUs");
